import React, { useState } from 'react';
import './CryptoForm.css';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import HowItWorks from './HowItWorks';

const Header = ({ darkMode, toggleDarkMode, hideToggle }) => {
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);

  const handleHowItWorksOpen = () => {
    setIsHowItWorksOpen(true);
  };

  const handleHowItWorksClose = () => {
    setIsHowItWorksOpen(false);
  };

  const handleToggleDarkMode = () => {
    toggleDarkMode();
    window.dispatchEvent(new Event('darkModeToggle'));
  };

  return (
    <header className="sticky-header" style={{ fontFamily: 'var(--font-family)', fontSize: 'var(--font-size-medium)' }}>
      <meta name="description" content="Rocket-Portfolio - Your gateway to the crypto world" />
      <meta name="keywords" content="crypto, Rocket-Portfolio, blockchain, cryptocurrency" />
      <meta name="author" content="Rocket-Portfolio Team" />
      <div className="header-title">
        <Typography variant="h6">
          Rocket-Portfolio
          <span className="beta-badge">BETA</span>
        </Typography>
      </div>
      <div className="header-buttons">
        <Tooltip title="How It Works">
          <IconButton onClick={handleHowItWorksOpen} color="inherit">
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
        {!hideToggle && (
          <IconButton className="mode-toggle" onClick={handleToggleDarkMode}>
            {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        )}
      </div>
      <HowItWorks open={isHowItWorksOpen} onClose={handleHowItWorksClose} />
    </header>
  );
};

export default Header;
